import React, { useState } from "react";
import { useInView } from "react-intersection-observer";

// components
import Carousel from "../../Carousel";
import VideoModal from "../TwinCanHelp/VideoModal";

// styles
import * as styles from "./SuccessStoriesV3.module.css";

const SuccessStoriesV3 = ({
  title,
  subTitle,
  handleMixpanelCTA,
  videoData = [],
  sessionId,
  updateSessionId,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const openVideo = video => {
    setSelectedVideo(video);
    setShowVideoModal(true);
    if (handleMixpanelCTA) {
      handleMixpanelCTA("Video Clicked", video.title || "Success Story Video");
    }
  };

  const closeVideo = () => {
    setShowVideoModal(false);
    setSelectedVideo(null);
  };

  return (
    <>
      <section className={styles.successStoriesWrapper}>
        <div
          ref={ref}
          className={`container scroll_animate ${inView && "inview"}`}
        >
          <div className="row">
            <div className="col-12">
              <div className={styles.headerSection}>
                <h1 className={styles.mainTitle}>{title}</h1>
                {subTitle && <p className={styles.subTitle}>{subTitle}</p>}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Carousel
                items={videoData}
                slidesToShow={3}
                slidesToShowTablet={2}
                slidesToShowMobile={1}
                gap={24}
                showDots={false}
                showArrows={false}
                autoPlay={true}
                arrowPosition="bottom-right"
                renderItem={(item, index) => (
                  <div
                    className={styles.videoCard}
                    onClick={() => openVideo(item)}
                    role="button"
                    tabIndex={0}
                    onKeyPress={e => {
                      if (e.key === "Enter" || e.key === " ") {
                        openVideo(item);
                      }
                    }}
                  >
                    <div className={styles.videoImageWrapper}>
                      <img
                        src={item.thumbnail}
                        alt={item.title || "Success Story"}
                        className={styles.videoImage}
                      />
                    </div>
                  </div>
                )}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {selectedVideo && (
        <VideoModal
          show={showVideoModal}
          onHide={closeVideo}
          videoLink={selectedVideo.videoLink}
          videoName={selectedVideo.title || "Success Story"}
          sessionId={sessionId}
          updateSessionId={updateSessionId}
        />
      )}
    </>
  );
};

export default SuccessStoriesV3;
